import React, { Component } from 'react';

import { pages } from '../../navigation/wolf';
import queryParser from '../../helpers/query-parser';
import Success from './components/success';
import Cancel from './components/cancel';
import PreCheckout from './components/pre-checkout';

export default class Checkout extends Component {
  component;

  userCancelledCheckout() {

  }

  userCompletedCheckout() {

  }

  handleFlow() {
    const params = queryParser(window.location.search);
    const successString = 'success';
    const cancelString = 'cancel';

    switch (params.status) {
      case successString:
        this.userCompletedCheckout();
        this.component = <Success />;
        break;
      case cancelString:
        this.userCancelledCheckout();
        this.component = <Cancel />;
        break;
      default:
        let base = window.location.href.split('?')[0];
        base += '?page=' + pages.CHECKOUT;

        const stripe = global.Stripe('pk_test_1ijyIKhk9cZJsYe7eGDzjBJl'); // eslint-disable-line
        stripe.redirectToCheckout({
          items: [
            { sku: 'sku_FrdR5TTVvQZEkz', quantity: 1 }
          ],
          successUrl: base + '&status=' + successString,
          cancelUrl: base + '&status=' + cancelString
        }).then((res) => {
          // Show Error?
        });
        this.component = <PreCheckout />;
    }
  }

  render() {
    this.handleFlow();
    return (
      <div>
        { this.component }
      </div>
    );
  }
}
